import { render, staticRenderFns } from "./addPhys.vue?vue&type=template&id=30eb4f06&"
import script from "./addPhys.vue?vue&type=script&lang=js&"
export * from "./addPhys.vue?vue&type=script&lang=js&"
import style0 from "./addPhys.vue?vue&type=style&index=0&id=30eb4f06&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports